<template>
  <section>
    <v-card class="card mb-4" color="primary">
      <v-card-text>
        <v-row justify="space-between">
          <v-col cols="8">
            <h3 class="font-weight-bold mb-2">{{ rubro.title }}</h3>
            <p class="black--text">{{ rubro.objetivo }}</p>
          </v-col>
          <v-col cols="auto">
            <v-chip :color="resultado === RESULTADOS.INSATISFACTORIO ? 'error' : 'success'" text-color="white">
              {{ resultado }}
            </v-chip>
          </v-col>
        </v-row>
      </v-card-text>
      <hr />
      <v-card-text>
        <v-row v-for="reactivo in reactivosOfRubro" :key="reactivo.id" align="center">
          <v-col cols="8">
            <p class="text-subtitle-1">{{ reactivo.descripcion }}</p>
          </v-col>
          <v-col cols="4">
            <BaseSelect label="Calificación" v-model="reactivo.calificacion" :items="frecuencias" />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import BaseSelect from '@src/components/base/BaseSelect.vue'
import { RESULTADOS } from '@src/modules/evaluacion-anual/domain/RESULTADOS'
import { TIPOS_EVALUACION_ANUAL } from '@src/modules/evaluacion-anual/domain/TIPOS_EVALUACION_ANUAL'

const PUNTAJE_CALIFICACION = {
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
}

export default {
  components: { BaseSelect },

  props: {
    rubro: {
      type: Object,
      required: true,
    },

    reactivos: {
      type: Array,
      required: true,
    },

    frecuencias: {
      type: Array,
      required: true,
    },

    tipoEvaluacion: {
      type: Number,
      default: TIPOS_EVALUACION_ANUAL.EVACOM,
    },
  },

  data() {
    return {
      RESULTADOS,
    }
  },

  computed: {
    reactivosOfRubro() {
      return this.reactivos.filter(({ idRubro }) => idRubro === this.rubro.id)
    },

    puntaje() {
      let total = 0

      this.reactivosOfRubro.forEach((reactivo) => {
        total += PUNTAJE_CALIFICACION[reactivo.calificacion] ?? 0
      })

      return total
    },

    resultado() {
      if (this.tipoEvaluacion === TIPOS_EVALUACION_ANUAL.EVACOM) {
        if (this.puntaje >= 31.5 && this.puntaje <= 35) {
          return RESULTADOS.EXCELENTE
        }

        if (this.puntaje >= 24.5 && this.puntaje <= 31.4) {
          return RESULTADOS.SATISFACTORIO
        }

        return RESULTADOS.INSATISFACTORIO
      }

      if (this.puntaje >= 22.5 && this.puntaje <= 25) {
        return RESULTADOS.EXCELENTE
      }

      if (this.puntaje >= 17.5 && this.puntaje <= 22.4) {
        return RESULTADOS.SATISFACTORIO
      }

      return RESULTADOS.INSATISFACTORIO
    },
  },
}
</script>
